import React, { useEffect, useRef } from "react";

const TradingViewWidget = ({ symbol, type, height = 600 }) => {
  const containerRef = useRef(null);
  const getResponsiveHeight = () => {
    if (typeof window === "undefined") return height;
    return window.matchMedia("(max-width: 768px)").matches ? 400 : height;
  };

  const loadWidget = (currentHeight) => {
    if (!containerRef.current) return;
    containerRef.current.innerHTML = "";
    try {
      const script = document.createElement("script");
      script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
      script.type = "text/javascript";
      script.async = true;

      let symbolPrefix = "";
      if (type === "crypto") {
        symbolPrefix = "BINANCE:";
      } else if (type === "stock") {
        symbolPrefix = "NASDAQ:";
      } else if (type === "forex") {
        symbolPrefix = "FX:";
      }
      script.innerHTML = JSON.stringify({
        width: "100%",
        height: currentHeight,
        symbol: `${symbolPrefix}${symbol}${symbolPrefix === "FX:" ? "" : symbolPrefix === "BINANCE:" ? "USDT" : ""}`,
        interval: "D",
        theme: "dark",
        style: "1",
        locale: "en",
        hide_top_toolbar: true,
        allow_symbol_change: true,
        save_image: false,
        support_host: "https://www.tradingview.com",
      });

      containerRef.current.appendChild(script);
    } catch (err) {
      console.error("TradingView widget load error:", err);
    }
  };
  useEffect(() => {
    loadWidget(getResponsiveHeight());
  }, [symbol, type]);
  useEffect(() => {
    const handleResize = () => {
      loadWidget(getResponsiveHeight());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [height]);

  return <div ref={containerRef} />;
};
export default TradingViewWidget;